import { get, omit, flow } from 'lodash/fp';
import { getSearchUrl } from 'helpers/namedUrls';
import { parseSearch, stringifyQuery } from 'helpers/location';
import { LOCALE } from 'helpers/i18n';
import {
  EXTRA_FILTERS_QUERY_KEY,
  LAST_SEARCH_LOCATION_KEY,
} from '../constants';

export const loadLocationFromStorage = (storageKey) =>
  function* () {
    try {
      return JSON.parse(
        sessionStorage.getItem(storageKey || LAST_SEARCH_LOCATION_KEY),
      );
    } catch (error) {
      return { pathname: getSearchUrl(LOCALE) };
    }
  };

export const saveLocationToStorage = (storageKey) =>
  function* ({ getCurrentLocation }) {
    const location = getCurrentLocation();

    try {
      const locationWithoutExtra = flow(
        get(['search']),
        parseSearch,
        omit([EXTRA_FILTERS_QUERY_KEY]),
        stringifyQuery,
        (search) => JSON.stringify({ ...location, search }),
      )(location);

      sessionStorage.setItem(storageKey, locationWithoutExtra);
      sessionStorage.setItem(LAST_SEARCH_LOCATION_KEY, locationWithoutExtra);
    } catch (error) {
      return null;
    }
  };
